import actions from './actions';
import {
  orderStatusMap,
  deliveryMethodTableMap,
  subsidyMethodTableMap,
  payOwnselfProportionMap
} from '@/utils/optionMaps';

export default {
  namespaced: true,
  state: {
    // state 常數
    areaTypeOptions: [
      {
        value: 0,
        text: '一般地區'
      },
      {
        value: 1,
        text: '次偏鄉地區'
      },
      {
        value: 2,
        text: '偏鄉地區'
      }
    ],
    classOptions: [
      {
        value: 0,
        text: '一般收入戶'
      },
      {
        value: 1,
        text: '中低收入戶'
      },
      {
        value: 2,
        text: '低收入戶'
      }
    ],
    districtOptions: {
      city: '高雄市',
      areas: [
        {
          value: '新興區',
          text: '新興區'
        },
        {
          value: '前金區',
          text: '前金區'
        },
        {
          value: '苓雅區',
          text: '苓雅區'
        },
        {
          value: '鹽埕區',
          text: '鹽埕區'
        },
        {
          value: '鼓山區',
          text: '鼓山區'
        },
        {
          value: '旗津區',
          text: '旗津區'
        },
        {
          value: '前鎮區',
          text: '前鎮區'
        },
        {
          value: '三民區',
          text: '三民區'
        },
        {
          value: '楠梓區',
          text: '楠梓區'
        },
        {
          value: '小港區',
          text: '小港區'
        },
        {
          value: '左營區',
          text: '左營區'
        },
        {
          value: '仁武區',
          text: '仁武區'
        },
        {
          value: '大社區',
          text: '大社區'
        },
        {
          value: '東沙群島',
          text: '東沙群'
        },
        {
          value: '南沙群島',
          text: '南沙群'
        },
        {
          value: '岡山區',
          text: '岡山區'
        },
        {
          value: '路竹區',
          text: '路竹區'
        },
        {
          value: '阿蓮區',
          text: '阿蓮區'
        },
        {
          value: '田寮區',
          text: '田寮區'
        },
        {
          value: '燕巢區',
          text: '燕巢區'
        },
        {
          value: '橋頭區',
          text: '橋頭區'
        },
        {
          value: '梓官區',
          text: '梓官區'
        },
        {
          value: '彌陀區',
          text: '彌陀區'
        },
        {
          value: '永安區',
          text: '永安區'
        },
        {
          value: '湖內區',
          text: '湖內區'
        },
        {
          value: '鳳山區',
          text: '鳳山區'
        },
        {
          value: '大寮區',
          text: '大寮區'
        },
        {
          value: '林園區',
          text: '林園區'
        },
        {
          value: '鳥松區',
          text: '鳥松區'
        },
        {
          value: '大樹區',
          text: '大樹區'
        },
        {
          value: '旗山區',
          text: '旗山區'
        },
        {
          value: '美濃區',
          text: '美濃區'
        },
        {
          value: '六龜區',
          text: '六龜區'
        },
        {
          value: '內門區',
          text: '內門區'
        },
        {
          value: '杉林區',
          text: '杉林區'
        },
        {
          value: '甲仙區',
          text: '甲仙區'
        },
        {
          value: '桃園區',
          text: '桃園區'
        },
        {
          value: '那瑪夏區',
          text: '那瑪夏'
        },
        {
          value: '茂林區',
          text: '茂林區'
        },
        {
          value: '茄萣區',
          text: '茄萣區'
        }
      ]
    },
    deliveryMethodOptions: [
      {
        value: 0,
        text: '就醫接送'
      },
      {
        value: 1,
        text: '社區式接送'
      },
      {
        value: 2,
        text: '社區式接送(共乘)'
      }
    ],
    subsidyMethodOptions: [
      {
        value: 0,
        text: '就醫接送'
      },
      {
        value: 1,
        text: '社區式接送'
      },
      {
        value: 2,
        text: '使用博愛卡'
      },
      {
        value: 3,
        text: '自費'
      }
    ],
    userHistoryAddressFields: [
      {
        key: 'address',
        label: '地址'
      },
      {
        key: 'longitude',
        label: '經度'
      },
      {
        key: 'latitude',
        label: '緯度'
      }
    ],
    serviceOptions: [],

    // state 長照單 List
    orders: [],
    ordersPagenation: {
      perPage: 25,
      currentPage: 1,
      orderStatus: 6,
      startDate: null,
      endDate: null,
      driverName: null,
      userName: null
    },
    ordersTotalStatus: {
      today: {
        total: 0,
        achievementRate: '0%',
        waitForDriver: 0,
        loadFactor: 0,
        waitForSubmit: 0
      },
      tomorrow: {
        total: 0,
        achievementRate: '0%',
        waitForDriver: 0,
        waitForSubmit: 0
      }
    },

    // state 長照單新增
    order: {
      orderStatus: null,
      userInformation: {},
      driverInformation: {},
      rideInformation: {},
      fareInformation: {},
      immediateInformation: {}
    },
    orderData: {
      longTermCareUserId: '',
      deliveryMethod: null,
      estimateGetOnTime: '',
      getOnTime: '',
      getOffTime: '',
      onLocation: '',
      onLocationGps: [],
      offLocation: '',
      offLocationGps: [],
      seat: 2,
      service: [],
      serviceNote: '',
      driverId: '',
      licenseNumber: '',
      subsidyMethod: null,
      milage: 0,
      metreFare: 0,
      subsidyFare: 0,
      actualFare: 0
    },
    orderDriverIDSearchResult: [],
    orderLicenseNumberSearchResult: [],

    // state 地址搜尋
    locationList: [],

    // state 長照用戶
    users: [],
    usersPagenation: {
      perPage: 25,
      currentPage: 1,
      keyword: '',
      subidyFare: ''
    },
    user: {
      address: '',
      gps: [],
      area: null,
      areaType: null,
      authority: false,
      class: null,
      communityShuttleFrequency: null,
      contactPerson: '',
      firstMobilePhoneNumber: '',
      identityCode: '',
      name: '',
      note: '',
      photo: null,
      secondMobilePhoneNumber: '',
      service: [],
      telephoneNumber: '',
      verification: false
    },
    userData: {},
    usersSearchResult: [],
    userHistoryAddress: [],
    userDetailSearchResult: {
      name: '',
      address: '',
      service: [],
      payForOwnselfProportion: null,
      selfPayRatio: null,
      subsidyLastAmount: null,
      lastCommunityShuttleFrequency: null,
      verification: false,
      historyAddressData: []
    },

    // state 下載參數與資料
    dailyRecordSearchResult: [],
    downloadPerpageOptions: [0]
  },
  mutations: {
    serviceOptions: (state, teamService) => (state.teamService = teamService),
    // mutations 長照單 List
    orders: (state, orders) => (state.orders = orders),
    ordersPagenation: (state, ordersPagenation) =>
      (state.ordersPagenation = {
        ...state.ordersPagenation,
        ...ordersPagenation
      }),
    ordersCurrentPage: (state, currentPage) =>
      (state.ordersPagenation.currentPage = currentPage),
    ordersPerPage: (state, perPage) =>
      (state.ordersPagenation.perPage = perPage),
    ordersTotalStatus: (state, totalStatus) =>
      (state.ordersTotalStatus = totalStatus),

    // mutations 長照單檢視與編輯
    order: (state, order) => (state.order = order),
    orderData: (state, orderData) => (state.orderData = orderData),
    orderDriverIDSearchResult: (state, orderDriverIDSearchResult) =>
      (state.orderDriverIDSearchResult = orderDriverIDSearchResult),
    orderLicenseNumberSearchResult: (state, orderLicenseNumberSearchResult) =>
      (state.orderLicenseNumberSearchResult = orderLicenseNumberSearchResult),

    // mutation 地址搜尋
    locationList: (state, locationList) => (state.locationList = locationList),

    // mutations 長照用戶
    users: (state, users) => (state.users = users),
    user: (state, user) => (state.user = user),
    userData: (state, userData) => (state.userData = userData),
    usersPagenation: (state, usersPagenation) =>
      (state.usersPagenation = {
        ...state.usersPagenation,
        ...usersPagenation
      }),
    usersSearchResult: (state, usersSearchResult) =>
      (state.usersSearchResult = usersSearchResult),
    userHistoryAddress: (state, userHistoryAddress) =>
      (state.userHistoryAddress = userHistoryAddress),
    userDetailSearchResult: (state, userDetailSearchResult) =>
      (state.userDetailSearchResult = userDetailSearchResult),

    // mutation 下載參數與資料
    dailyRecordSearchResult: (state, dailyRecordSearchResult) =>
      (state.dailyRecordSearchResult = dailyRecordSearchResult),
    downloadPerpageOptions: (state, downloadPerpageOptions) =>
      (state.downloadPerpageOptions = downloadPerpageOptions)
  },
  getters: {
    // getters 常數
    areaTypeOptions: state => state.areaTypeOptions,
    classOptions: state => state.classOptions,
    districtOptions: state => state.districtOptions,
    deliveryMethodOptions: state => state.deliveryMethodOptions,
    subsidyMethodOptions: state => state.subsidyMethodOptions,
    userHistoryAddressFields: state => state.userHistoryAddressFields,
    serviceOptions: state => {
      return state.teamService.map(service => ({
        value: service.teamServiceId,
        text: service.name
      }));
    },

    // getters 長照單 List
    orders: state => {
      if (!state.orders.length) return [];

      return state.orders.map(order => {
        return {
          ...order,
          orderStatus: orderStatusMap(order.orderStatus),
          address: {
            onLocation: order.onLocation,
            offLocation: order.offLocation
          },
          user: {
            name: order.userName,
            number: order.contactNumber
          },
          delivery: {
            methodValue: order.deliveryMethod,
            method: deliveryMethodTableMap(order.deliveryMethod),
            licenseNumber: order.licenseNumber
          },
          subsidy: {
            methodValue: order.subsidyMethod,
            method: subsidyMethodTableMap(order.subsidyMethod),
            licenseNumber:
              order.subsidyMethod === 2 || order.subsidyMethod === 3
                ? ''
                : order.licenseNumber
          },
          payOwnselfProportion: payOwnselfProportionMap(
            order.payOwnselfProportion
          ),
          metreFare: `跳 NT ${order.metreFare ? order.metreFare : 0}`,
          fare: {
            subsidyFare: `補 NT ${order.subsidyFare ? order.subsidyFare : 0}`,
            actualFare: `實 NT ${order.actualFare ? order.actualFare : 0}`
          }
        };
      });
    },
    ordersPagenation: state => state.ordersPagenation,
    ordersTotalStatus: (state, getters) => {
      return {
        today: {
          ...state.ordersTotalStatus.today,
          achievementRate: getters.achievementRateCaculate(
            'today',
            state.ordersTotalStatus.today
          )
        },
        tomorrow: {
          ...state.ordersTotalStatus.tomorrow,
          achievementRate: getters.achievementRateCaculate(
            'tomorrow',
            state.ordersTotalStatus.tomorrow
          )
        }
      };
    },
    achievementRateCaculate: () => (type, dataObj) => {
      if (dataObj.total === 0) {
        return 0;
      } else {
        if (type === 'today') {
          return Math.round((dataObj.loadFactor / dataObj.total) * 100);
        }
        if (type === 'tomorrow') {
          return Math.round((dataObj.waitForDriver / dataObj.total) * 100);
        }
      }
    },

    // getters 長照單檢視與編輯
    order: state => {
      return {
        ...state.order,
        ...state.orderData
      };
    },
    orderData: state => state.orderData,
    orderDriverIDSearchResult: state => {
      return state.orderDriverIDSearchResult.map(item => {
        item['value'] = `${item.callNumber}-${item.name}`;
        return item;
      });
    },
    orderLicenseNumberSearchResult: state => {
      return state.orderLicenseNumberSearchResult.map(item => {
        item['value'] = item.licenseNumber;
        return item;
      });
    },

    // getters 地址搜尋
    locationList: state => {
      return state.locationList.map(item => {
        const value = item.address;
        return {
          value: value,
          address: value,
          longitude: item.gps.coordinates[0],
          latitude: item.gps.coordinates[1],
          id: item.id ? item.id : null,
          name: item.name ? item.name : null
        };
      });
    },

    // getters 長照用戶
    users: state => state.users,
    usersPagenation: state => state.usersPagenation,
    user: state => {
      return {
        ...state.user,
        service: state.user.service.map(item => {
          if (item.teamServiceId) return item.teamServiceId;
          return item;
        }),
        gps: state.user.addressGps.join(','),
        ...state.userData
      };
    },
    usersSearchResult: state => state.usersSearchResult,
    userDetailSearchResult: state => state.userDetailSearchResult,
    userHistoryAddress: state => state.userHistoryAddress,

    // getters 下載參數與資料
    dailyRecordSearchResult: state => state.dailyRecordSearchResult,
    downloadPerpageOptions: state => state.downloadPerpageOptions
  },
  actions
};
